import { toast } from 'react-toastify'

export const toastWithErrorMessage = text => err => {
  toast.error([text, err.message].filter(a => a).join(': '))
}
